export default __webpack_public_path__ + "static/media/truck.3f8b749a.svg";